// extracted by mini-css-extract-plugin
module.exports = {"blob":"Dot-module--blob--1LhIJ","contentRow":"Dot-module--contentRow--3Mat0","contentDescription":"Dot-module--contentDescription--14cwY","dot":"Dot-module--dot--1o6Ba"};